import { render, staticRenderFns } from "./Rekurskommission.vue?vue&type=template&id=7af538d0&scoped=true&"
import script from "./Rekurskommission.vue?vue&type=script&lang=js&"
export * from "./Rekurskommission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af538d0",
  null
  
)

export default component.exports